import { ShortVideoContentItemProps } from '@components/report/content-items/short-video-content-item/ShortVideoContentItem';

import { YTContentData, YTReportRes } from '@apis/orval/model';

import { ShortsContentProps } from './ShortsContent';

export class ShortsContentAdapter {
	value: YTReportRes;
	constructor(obj: YTReportRes) {
		this.value = obj;
	}

	get videoContents() {
		return this.value?.content?.recent_shorts_contents ?? [];
	}

	sortContents(contents: YTContentData[], sortBy: 'newest' | 'views') {
		if (sortBy === 'newest')
			return contents.sort(
				(a, b) =>
					new Date(b.upload_at ?? 0).getTime() - new Date(a.upload_at ?? 0).getTime(),
			);
		else if (sortBy === 'views')
			return contents.sort((a, b) => (b.view_count ?? 0) - (a.view_count ?? 0));

		return contents;
	}

	getShortsContentItemProps(videoContentData: YTContentData): ShortVideoContentItemProps {
		return {
			outLink: videoContentData.content_link ?? undefined,
			imgSrc: videoContentData.content_img_link ?? undefined,
			viewCount: videoContentData.view_count ?? undefined,
			contentText: videoContentData.content_title ?? undefined,
			isPaidAd: videoContentData.is_ad ?? undefined,
		};
	}

	adapt(sortBy: 'newest' | 'views'): ShortsContentProps {
		return {
			items: this.sortContents(this.videoContents, sortBy).map((videoContentData) =>
				this.getShortsContentItemProps(videoContentData),
			),
		};
	}
}
